import { useApi } from "shared/services/api/useApi";
import { useCallback } from "react";

export const useProjects = () => {
    const { getDataAsync } = useApi();

    const getProjectsFilter = useCallback(async (
        clientfamiliesIds,
        clientIds,
        retainerIds
    ) => {
        const params = {
            clientfamilies: clientfamiliesIds,
            clientIds: clientIds,
            retainerIds: retainerIds,
        };
        const payload = await getDataAsync("projectsFilters", { params: params });
        return payload.json();
    }, [getDataAsync]);

    const getProjectsFiltersByClientFamily = useCallback(async (clientFamilyId) => {
        const urlParams = [{ name: "$clientFamilyId", value: clientFamilyId }];
        const payload = await getDataAsync("projectsFiltersByClientFamily", {
            urlParams: urlParams,
        });
        return payload.json();
    }, [getDataAsync]);

    const getProjectsFiltersByClient = useCallback(async (clientId) => {
        const urlParams = [{ name: "$clientId", value: clientId }];
        const payload = await getDataAsync("projectsFiltersByClient", {
            urlParams: urlParams,
        });
        return payload.json();
    }, [getDataAsync]);

    const getProjectsFiltersByRetainer = useCallback(async (retainerId) => {
        const urlParams = [{ name: "$retainerId", value: retainerId }];
        const payload = await getDataAsync("projectsFiltersByRetainer", {
            urlParams: urlParams,
        });
        return payload.json();
    }, [getDataAsync]);

    const getProjectDetail = useCallback(async (urlParams) => {
        const payload = await getDataAsync("projectDetail", { urlParams: urlParams });
        return payload.json();
    }, [getDataAsync]);

    return {
        getProjectsFilter,
        getProjectsFiltersByClientFamily,
        getProjectsFiltersByClient,
        getProjectsFiltersByRetainer,
        getProjectDetail,
    };
};
